/**
 * Created by razial on 18.09.2026.
 */

Mission.TYPE_COLLECTIONS_PASS = 66;

ManualStarters.clPassStarter = function (type) {
    if (!cleverapps.user.checkAvailable(Missions[type].available)) {
        return false;
    }

    if (!Missions[type].cooldown) {
        return true;
    }
    const lastRemoved = cleverapps.missionManager.getLastRemoved(type);
    return lastRemoved + cleverapps.parseInterval(Missions[type].cooldown) < Date.now();
};

Mission.REGISTRATIONS.set(Mission.TYPE_COLLECTIONS_PASS, () => ({
    name: "CollectionsPass",
    view: ExpeditionPassWindow,
    startWindow: ExpeditionPassWindow,
    finishWindow: ExpeditionPassWindow,
    location: "collections",
    sideBarJson: function () {
        return cleverapps.skins.getSlot("expedition_buildpass_icon_json");
    },
    logic: PassMissionLogic,
    levels: PassLevelsConfig.collectionspass,
    sideBarSlotName: "expeditionBuildPassSideBarIcon",
    lastChanceView: PassLastChanceWindow,
    collectIcon: function () {
        return cleverapps.skins.getSlot("pass_star_png") || bundles.reward_icons_pass.frames.pass_star_png;
    },
    collectItemName: "star",
    mapPoints: true,
    eventPrefix: function () {
        return cleverapps.meta.selectedLocationId();
    },
    duration: "10 days",
    cooldown: "7 days",
    manualStart: ManualStarters.clPassStarter,
    available: cleverapps.config.availables.COLLECTIONS_PASS_MISSION
}));
